import { Auth0Provider } from '@auth0/auth0-react';
import React, { memo, ReactNode } from 'react';
import { useHistory } from "react-router-dom";
import environment from '../environment/environment';

const Auth0ProviderWithNavigate = memo(({ children }) => {
  const history = useHistory();


  const onRedirectCallback = (appState) => {

    // Remove code and state parameters from URL
    const url = new URL(window.location);
    url.searchParams.delete('code');
    url.searchParams.delete('state');

    // Navigate to target URL or default
    const targetUrl = appState?.targetUrl || '/';

    // Clean the browser URL without the auth parameters
    window.history.replaceState({}, document.title, url.pathname + url.hash);

    // Navigate to the target route
    history.replace(targetUrl);
  };

  const providerConfig = {
    domain: environment.AUTH_DOMAIN,
    clientId: environment.AUTH_CLIENT_ID,
    onRedirectCallback,
    authorizationParams: {
      // redirect_uri: `${window.location.origin}/sales/`,
      redirect_uri: `${window.location.origin}${environment.DOMAIN_PATH}`,
      audience: 'cms-black-authentication-auth',
    },
    useRefreshTokens: true,
    cacheLocation: 'localstorage',
  };

  return (
    <Auth0Provider {...providerConfig}>
      {children}
    </Auth0Provider>
  );
});

export default Auth0ProviderWithNavigate;
